{
  "back": "Back",
  "form": "Form",
  "purposeTitle": "What's the purpose of your stop?",
  "appointmentInfoTitle": "Appointment information",
  "appointmentInfoHint": "Make sure to fill in this field if you have an appointment.",
  "checkInDetailsTitle": "Check-in Details",
  "checkInDetailsHint": "Additional information about your visit.",
  "driverPhoneLabel": "Driver's Phone Number",
  "activateWhatsAppTitle": "Activate WhatsApp Messaging",
  "activateWhatsAppBody": "To chat with the warehouse, please reply \"OK\" when we send you the first WhatsApp message.",
  "whatsappDelayBanner": "The first WhatsApp message may take up to one minute to arrive.",
  "notesLabel": "Notes",
  "notesPlaceholder": "Any special instructions or notes to the facility?",
  "addNoteToWarehouse": "Add note to warehouse",
  "verifyAndCheckIn": "Verify and check-in",
  "completeCheckIn": "Complete check-in",
  "visitGroupInbound": "Inbound",
  "visitGroupOutbound": "Outbound",
  "visitGroupBoth": "Inbound & Outbound",
  "visitUnloadTruck": "Unload my truck",
  "visitDropTrailer": "Drop my trailer or container",
  "visitLoadTruck": "Load my truck",
  "visitHookTrailer": "Hook a trailer or container",
  "visitUnloadLoad": "Unload & Load my truck",
  "visitDropHook": "Drop & Hook a trailer or container",
  "containerTrailer": "Trailer",
  "containerContainer": "Container",
  "containerOversized": "Oversized",
  "containerOther": "Other",
  "defaultReferenceName": "PO Number",
  "identifierSuffix": "{reference} or Confirmation Number",
  "licenseOrDotRequired": "Please fill in License Plate or DOT Number",
  "appointmentNotFound": "We could not locate your appointment",
  "referenceNotFound": "No matching appointment found. Reference numbers are case sensitive.",
  "referenceCaseSensitiveHint": "The reference number is case sensitive",
  "messaging": {
    "whatsappFailedTitle": "Unable to send WhatsApp message",
    "smsFailedTitle": "Unable to send SMS message",
    "whatsappFailedBody": "We couldn't send a message to {displayPhone}. <br /><br /> If you have previously unsubscribed, please text START to <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> to start receiving messages from this warehouse.",
    "smsFailedBody": "We couldn't send a message to {displayPhone}. <br /><br /> If you have previously unsubscribed, please text START to <a href='{smsUrl}'>{senderPhone}</a> to start receiving SMS messages from this warehouse.",
    "fallbackPhone": "the provided phone number"
  }
}
